export default "__VITE_ASSET__CntSpMG8__"